import EmailToken from '@apps/automation/admin/tokens/email'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Emails)',
  collection: {
    endpoint: `/api/admin/campaigns/voice/${props.voice_campaign.id}/emails`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (email) => (
        <EmailToken { ...email } />
      ) }
    ],
    empty: {
      title: 't(No Emails)',
      text: 't(There are no emails for this voice campaign)',
      svg: 'mail'
    },
    entity: 'email',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/automation/emails/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
